var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('heard',{attrs:{"title":'老年多模态多媒体语料库切分标注平台'}}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"}),_c('userList',{attrs:{"current":'mmse'}})],1),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }